module.exports = __webpack_public_path__ + "img/ellipse_seal.edac2692.png";